<template>
  <svg
    class="pa-gantt__dependencies"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    preserveAspectRatio="none"
  >
    <component
      :is="path.is"
      v-for="(path, i) in dependenciesPaths"
      :key="`dependency-${i}`"
      v-bind="path"
    />
  </svg>
</template>

<script>
const BAR_H = 21

export default {
  props: {
    dependencies: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dependenciesPaths: []
    }
  },
  watch: {
    width () { this.drawDependencies() },
    height () { this.drawDependencies() },
    dependencies () { this.drawDependencies() }
  },
  mounted () {
    this.drawDependencies()
  },
  methods: {
    drawDependencies () {
      this.dependenciesPaths = []

      for (let dependency of this.dependencies) {
        const from = document.getElementById(`task-${dependency[0]}`)
        const to = document.getElementById(`task-${dependency[1]}`)

        if (!from || !from.offsetParent || !to || !to.offsetParent) {
          // at least one of the 2 bars is not visible
          continue
        }

        /**
         * Draw a connector with 2 circles
         * o----
         *      |
         *       ----o
         */
        const startX = from.offsetLeft + from.offsetWidth

        this.dependenciesPaths.push({
          is: 'path',
          d: `M${startX} ${from.parentElement.offsetTop + BAR_H}
          h${(to.offsetLeft - startX) / 2}
          V${to.parentElement.offsetTop + BAR_H}
          h${(to.offsetLeft - startX) / 2}`
        })

        this.dependenciesPaths.push({
          is: 'circle',
          cx: startX,
          cy: from.parentElement.offsetTop + BAR_H,
          r: 4
        })

        this.dependenciesPaths.push({
          is: 'circle',
          cx: to.offsetLeft,
          cy: to.parentElement.offsetTop + BAR_H,
          r: 4
        })
      }
    }
  }
}
</script>

<style lang="scss">
.pa-gantt__dependencies {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  path {
    stroke: gold;
    stroke-width: 2;
    stroke-linejoin: round;
    fill: none;
  }

  circle {
    fill: gold;
  }
}
</style>
